import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import { ErrorResponse } from '../services/HttpResponse';
import { useError, ErrorContextInterface } from '../contexts/Error';

interface ErrorCodeType {
  setErrorCode: ({ status }: ErrorResponse) => void;
}

export const useErrorCode = (): ErrorCodeType => {
  const ErrorContext = useError();
  const { t } = useTranslation();

  const setErrorContextCode = (
    ctx: ErrorContextInterface,
    code: string | number
  ): void => {
    ctx.setError({
      title: t(`error.title-${code}`),
      text: t(`error.description-${code}`),
      btnText: t(`error.httpStatusBtnText`),
    });
  };
  // Don't extract to separate method since it's using the Contexts
  const setErrorCode = ({ status, data = {} }: ErrorResponse): void => {
    const errorStatus =
      [400, 404, 500, 504].indexOf(status) === -1 ? 500 : status;

    if (data && data.serviceError) {
      const serviceCodeError = data.serviceError.toLowerCase();
      if (serviceCodeError === 'blocked') {
        setErrorContextCode(ErrorContext, serviceCodeError);
        return;
      }
    }
    setErrorContextCode(ErrorContext, errorStatus);
  };
  return { setErrorCode };
};
